
export const projects = [
    {
        // Spring Ville Greens PH-1
        id: 1,
        title: 'SpringVille Greens PH-1',
        bgImage: require('./../../images/projects/springvillegreens/springville_PH1_bg.webp'),
        image1: require('./../../images/projects/springvillegreens/SpringVille_PH1_1.webp'),
        image2: require('./../../images/projects/springvillegreens/SpringVille_PH1_2.webp'),
        image3: require('./../../images/projects/springvillegreens/SpringVille_PH1_3.webp'),
        image4: require('./../../images/projects/springvillegreens/SpringVille_PH1_4.webp'),
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'Completed',
        address: 'Bhubaneswar',
        filter: 'col-two',
        description: '',
    },
    {
        // Spring Ville Greens PH-2
        id: 2,
        title: 'SpringVille Greens PH-2',
        bgImage: require('./../../images/projects/springvillegreens/springville_PH2_bg.webp'),
        image1: require('./../../images/projects/springvillegreens/SpringVille_PH2_1.webp'),
        image2: require('./../../images/projects/springvillegreens/SpringVille_PH2_2.webp'),
        image3: '',
        image4: '',
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'Ongoing',
        address: 'Bhubaneswar',
        filter: 'col-one',
        description: '',
    },
    {
        // Spring Ville Club House
        id: 3,
        title: 'SpringVille Greens Club House',
        bgImage: require('./../../images/projects/springvillegreens/springville_club_house_bg.webp'),
        image1: require('./../../images/projects/springvillegreens/springville_club_house_thumb1.webp'),
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'Completed',
        address: 'Bhubaneswar',
        filter: 'col-two',
        description: '',
    },
    {
        // Sunrise Aura
        id: 4,
        title: 'Sunrise Aura',
        bgImage: require('./../../images/projects/sunriseaura/sun-riseaura-PH1_bg.webp'),
        image1:  require('./../../images/projects/sunriseaura/sun-riseaura-PH1_1.webp'),
        image2:  require('./../../images/projects/sunriseaura/sun-riseaura-PH1_2.webp'),
        image3: '',
        image4: '',
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'Ongoing',
        address: 'Kolkata',
        filter: 'col-one',
        description: '',
    },
    {
        //ATC Ultima
        id: 5,
        title: 'ATC Ultima',
        bgImage: require('./../../images/projects/atcultima/atc_ultima_bg.webp'),
        image1: require('./../../images/projects/atcultima/atc_ultima_1.webp'),
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'Ongoing',
        address: 'Jamshedpur',
        filter: 'col-one',
        description: '',
    },
    {
        //Beaumonde
        id: 6,
        title: 'BeauMonde',
        bgImage: require('./../../images/projects/beaumonde/beaumonde_bg.webp'),
        image1: require('./../../images/projects/beaumonde/beaumonde-1.webp'),
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'Ongoing',
        address: 'Kolkata',
        filter: 'col-one',
        description: '',
    },
    {
        //Club House Meadows
        id: 7,
        title: 'Club House Meadows',
        bgImage: require('./../../images/projects/clubhousemeadows/clubhousemeadows_bg.webp'),
        image1: require('./../../images/projects/clubhousemeadows/clubhousemeadows_1.webp'),
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image6: '',
        videoUrl: '',
        videoImage: '',
        client:'',
        valu:'',
        status:'70% Completed',
        address: 'Baruipur',
        filter: 'col-two',
        description: '',
    }

]